export enum DdoColumn {
    orderNumber = 'Order #',
    doCreated = 'DO Created',
    status = 'Status',
    type = 'Type',
    container = 'Container Number',
    containerType = 'Container Type',
    ssl = 'SSL',
    loadType = 'Load Type',
    bookingBL = 'Booking/BL',
    referenceNumber = 'Reference #',
    poNumber = 'PO Number',
    chassis = 'Chassis',
    pickupLocation = 'Pickup Location',
    pickupPlannedDate = 'Pickup Planned',
    deliveryLocation = 'Delivery Location',
    deliveryActivity = 'Delivery Activity',
    activityPlannedDate = 'Activity Planned',
    activityCompletionDate = 'Activity Completion',
    appointmentPlannedDate = 'Appointment',
    appointmentConfirmed = 'Appt Date Status',
    returnLocation = 'Return Location',
    returnPlannedDate = 'Return Planned',
    daysOut = 'Days Out',
    firstReceivingDate = 'First Receiving',
    cutoffDate = 'Cutoff',
    lfdDate = 'LFD',
    etaDate = 'ETA',
    documents = 'Documents',
}

export enum SortDirection {
    ASC = 'asc',
    DESC = 'desc',
    NONE = 'none',
}

export interface SortConfig {
    column: DdoColumn | null
    direction: SortDirection
}

export enum AppointmentConfirmed {
    Delivered = 'Delivered',
    Confirmed = 'Confirmed',
    NotConfirmed = 'Not Confirmed',
}
